import './conversation_attribute_view.js.coffee'

class Customer.FreeTextAttributeView extends Customer.ConversationAttributeView
  template: JST['backbone/templates/customer/custom_attributes/free_text']
  baseTemplate: JST['backbone/templates/customer/custom_attributes/values/base']
  valueTemplate: JST['backbone/templates/customer/custom_attributes/values/free_text']

  render: =>
    super()
    @addModelValues()
    @updateDisabled()
    @disableFirstDelete()
    @_renderError()
    @

  addModelValues: ->
    _.each @model.get('value'), (value) =>
      @appendValue(value['value'])
    @appendValue('') if _.isEmpty(@model.get('value'))

  addNewValue: =>
    @appendValue('').find('.input').focus()
    @modifyAnything()
    @autoResizeInput()

  autoResizeInput: =>
    @$el.find('textarea.input').on 'input propertychange', @resizeInput

  resizeInput: (event) ->
    textarea = event.currentTarget || event
    paddingHeight = @_parseIntProperty(textarea, 'padding-top') + @_parseIntProperty(textarea, 'padding-bottom')
    textarea.style.height = '' # reset the height
    textarea.style.height = "#{textarea.scrollHeight - paddingHeight}px"

  _parseIntProperty: (element, property) ->
    parseInt($(element).css(property).replace(/px/, ''))

  _input: ->
    @$el.find('.input')

  getAdded: ->
    newValues = @getValues
      additionalValueSelector: '.new-value:not(.deleted-value)'
      inputSelector: '.input'
      validationRequired: true
    editableInputs = @getEditable(true)
    editedValues = _.difference(editableInputs.values, @initialValues())
    newValues.values = newValues.values.concat(editedValues)
    return null if _.isEmpty(newValues.values)
    newValues

  getDeleted: ->
    deletedValues = @getValues
      additionalValueSelector: '.deleted-value:not(.new-value)'
      inputSelector: '.input'
      validationRequired: false
    editableInputs = @getEditable(false)
    editedValues = _.difference(@initialValues(), editableInputs.values)
    deletedValues.values = deletedValues.values.concat(editedValues)
    return null if _.isEmpty(deletedValues.values)
    deletedValues

  getEditable: (validationRequired) ->
    @getValues
      additionalValueSelector: ':not(.new-value, deleted-value)'
      inputSelector: '.input'
      validationRequired: validationRequired

  getValues: ({additionalValueSelector, inputSelector, validationRequired}) =>
    values = []
    @$el.find(".value#{additionalValueSelector || ''}").find(inputSelector).each (_index, inputElement) ->
      if $(inputElement).isInputValid() or !validationRequired
        value = $(inputElement).val().trim()
        values.push value if String(value)

    definition_code: @model.get('definition').get('code'),
    values: _.filter(values, (value) -> value != null)

  appendValue: (value) =>
    $value = $(@baseTemplate())
    $value.find('.value-container').html($(@valueTemplate(
      value: value
      multiple: @model.get('definition').get('multiple')
    )))

    $value.find('.value').addClass('new-value') if value == ''

    $value.find('.input').on('change keyup', @modifyAnything)
                         .on('change cut', @modifyAnything)
                         .on('change paste', @modifyAnything)

    @$el.find('.values').append($value)
    $value.find('.delete-value .icon').on('click', @deleteValue)
    $value.find('.add-new-value').on 'click', =>
      @addNewValue()
    $value

  deleteValue: (event) =>
    $(event.target).closest('.value').addClass('deleted-value')
    @modifyAnything()

  modifyAnything: (event) =>
    @updateDisabled()
    @validateValueInput(event)

  validateValueInput: (event) ->
    return unless event
    valid = event.target.checkValidity()
    if valid then @processValidInput(event.target) else @processInvalidInput(event)

  processValidInput: (element) ->
    @clearErrorMessages(element)
    @trigger('custom_attributes:valid_attribute')

  processInvalidInput: (event) ->
    errors = @getErrorMessages(event)
    @_renderErrorMessages(event.target, errors)
    @trigger('custom_attributes:invalid_attribute')

  getErrorMessages: (_event) ->
    []

  _renderErrorMessages: (element, errors) =>
    $(element).closest('.value').find('.errors').html(
      errors.map(@_errorTemplate)
    )

  clearErrorMessages: (element) ->
    @_renderErrorMessages(element, [])

  validValue: =>
    _.every(@visibleInputs(), (input) -> input.checkValidity())

  visibleInputs: ->
    @$el.find('.value:not(.deleted-value)').find('.input')

  updateDisabled: =>
    $last = @$el.find('.value:not(.deleted-value):last').find('.input')

    thereAreNoValues = @visibleInputs().length == 0
    canAddMultiple = @model.get('definition').get('multiple')
    lastValueIsValid = ($last.length == 0) or ($last.length != 0 and $last.val().trim() != '' and $last.isInputValid())

    canAddNewValue = lastValueIsValid and canAddMultiple
    canAddNewValue ||= thereAreNoValues

    if canAddNewValue
      @_enableOnlyLastAddNewValueButton()
    else
      @_disableAddNewValueButtons()

  disableFirstDelete: ->
    firstValue = @$el.find('.value:not(.deleted-value):first')
    firstValue.find('.delete-value').prop('hidden', true)
    firstValue.find('.input').removeClass('deletable')

  _enableOnlyLastAddNewValueButton: ->
    @$el.find('.value:not(.deleted-value):last').find('.add-new-value')
                                                .removeClass('disabled')
                                                .prop('disabled', false)

    @$el.find('.value:not(.deleted-value):not(:last)').find('.add-new-value')
                                                      .addClass('disabled')
                                                      .prop('disabled', true)

  _disableAddNewValueButtons: ->
    @$el.find('.add-new-value').addClass('disabled')
                               .prop('disabled', true)

  afterRender: ->
    _.each(@$el.find('textarea.input'), (textarea) =>
      @resizeInput(textarea)
    )

  _renderError: ->
    errors = @model.getErrors()
    @_renderSelectRedBorder() if @model.error || (errors && errors.length)

  _renderSelectRedBorder: () =>
    @$el.find('textarea.input').addClass('error')
